import {Typography} from "@mui/material";
import {connect} from "react-redux";
export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
  }) => ({
    i18n,
    isLoading,
  }),
  {
    // redux functions
  }
)((props) => {
  let i18n = props.i18n;
  const isLoading = props.isLoading;
  return (
    <div className="card-service">
      <Typography variant="h1">{i18n.your_advantage}</Typography>
      <div className="card-frame">
        <div>
          <p className="checkMark-text">
            <img className="icon" src="../images/check_circle.svg" />
            Sichere Datenübertragung
          </p>
          <p className="checkMark-text">
            <img className="icon" src="../images/check_circle.svg" />
            iOS + Android-App verfügbar
          </p>
          <p className="checkMark-text">
            <img className="icon" src="../images/check_circle.svg" />
            Sofortige Bereitstellung
          </p>
        </div>
        <img
          src="./images/image.svg"
          style={{width: "35%", height: "100%"}}
          alt="Service quality future"
        />
      </div>
    </div>
  );
});
